import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { UIThemeContextProvider } from './contexts/UIThemeContext';

ReactDOM.render(
    <React.StrictMode>
        <UIThemeContextProvider>
            <App />
        </UIThemeContextProvider>
    </React.StrictMode>,
    document.getElementById('root')
);
